export default __webpack_public_path__ + "static/help-center-video-ccb03dd86af1b6580f1cbecb92cca259.mp4";